import React from 'react'
import PropTypes from 'prop-types'
import {Text, Divider, Stack, Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage, useIntl} from 'react-intl'
import {orderDetailStyle} from './info.style'

export const OrderInfo = ({isLoading, order}) => {
    const {formatDate} = useIntl()
    return !isLoading ? (
        <Stack sx={orderDetailStyle} divider={<Divider orientation="vertical" />}>
            <Text as="span">
                <FormattedMessage
                    defaultMessage="Ordered: {date}"
                    id="account_order_detail.label.ordered_date"
                    values={{
                        date: formatDate(new Date(order.creationDate), {
                            year: 'numeric',
                            day: 'numeric',
                            month: 'numeric'
                        })
                    }}
                />
            </Text>
            <Text as="span">
                <FormattedMessage
                    defaultMessage="Order Number: {orderNumber}"
                    id="account_order_detail.label.order_number"
                    values={{orderNumber: order.orderNo}}
                />
            </Text>
            <Text as="span">
                <FormattedMessage
                    defaultMessage="Order Status: {orderStatus}"
                    id="account_order_detail.label.order_status"
                    values={{orderStatus: order?.externalOrderStatus || order.status}}
                />
            </Text>
        </Stack>
    ) : (
        <Skeleton h="20px" w="192px" />
    )
}

OrderInfo.propTypes = {
    isLoading: PropTypes.bool,
    order: PropTypes.any
}
